import { ACTIONS } from "../../_config";
import { ActionExtended } from "../../_config/interfaces/interfaces";

export interface OrderFilters {
    orderDateRange?: [Date | null, Date | null];
    searchOrder?: string;
    searchCustomer?: string;
    customerEmail?: string;
    customerMobile?: string;
    orderStatus?: any;
    paymentStatus?: any;
    orderSource?: any;
    orderLocation?: any;
}

export interface OrdersReducer {
    orders: any[] | null;
    filters: OrderFilters | null;
}

const initialState: OrdersReducer = {
    orders: null,
    filters: null,
};

const ordersReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.ORDERS.SET_ORDER_FILTERS:
            return {
                ...state,
                filters: action.payload,
            };
        
        case ACTIONS.ORDERS.CLEAR_ORDER_FILTERS:
            return {
                ...state,
                filters: null,
            };

        default:
            return state;
    }
};

export default ordersReducer;
